import React, { Component} from "react";
import ReactDOM from "react-dom";
import {DoubleRange} from "./Components/DoubleRange"
import {CorGraph} from "./Components/CorGraph.js"
require("./common.scss");
require("./corellation.scss");

class CorrelationDemo extends Component{
  constructor(props){
    super(props);
    this.state = {
        value: 0,
    }
  }

  render(){
    return (
      <div className="CorrelationDemo">
      <h2>Correlation coefficient </h2>
      <p className='intro'>Adjust the correlation coefficient with the slider to see how the distribution is affected.</p>
      <div style={{
         marginTop: "36px",
         display: "flex",
         flexDirection: "row",
         alignItems: "center"
      }}>
      <div style={{marginRight:"10px"}}>-1</div>
      <DoubleRange 
      min={-1} 
      max={1} 
      values={[0]} 
      integer={false} 
      step={0.01} 
      pipsFormat = { (p)=>p }
      tooltipsFormat = { (p)=> parseInt(p*100)/100 }
      moveHandler = { (p)=>this.setState({value:+p[0]}) }
      />
      <div style={{marginLeft:"10px"}}>1</div>
      </div>

      <CorGraph value={this.state.value}/>
      </div>
    )
  }
}

ReactDOM.render(
    <CorrelationDemo />,
    document.getElementById("viz")
)
